import { useState } from 'react';
import { searchSuggestions, siteName } from '@/mocks/manga';

const heroCovers = [
  'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20an%20elegant%20star%20goddess%20with%20flowing%20silver%20hair%20and%20golden%20ornaments%2C%20starry%20night%20background%2C%20dreamy%20soft%20lighting%2C%20high%20detail%2C%20portrait&width=480&height=640&seq=hero-card-1&orientation=portrait',
  'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20moon%20goddess%20descending%20from%20a%20crescent%20moon%20with%20pale%20glow%2C%20elegant%20flowing%20robes%2C%20mystical%20romantic%20atmosphere%2C%20portrait&width=480&height=640&seq=hero-card-2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20goddess%20awakening%20with%20radiant%20wings%20of%20light%20and%20glowing%20energy%2C%20epic%20dramatic%20pose%2C%20luminous%20background%2C%20portrait&width=480&height=640&seq=hero-card-3&orientation=portrait',
];

export default function Hero() {
  const [keyword, setKeyword] = useState('');

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const key = keyword.trim() || '星辉女神录';
    const el = document.getElementById('hot');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setKeyword(key);
  };

  const goHot = () => {
    const el = document.getElementById('categories');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative overflow-hidden bg-gradient-to-br from-primary-100 via-background-50 to-accent-100"
    >
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary-200/50 blur-3xl" />
      <div className="pointer-events-none absolute -left-16 bottom-0 h-72 w-72 rounded-full bg-accent-200/50 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 pb-16 pt-28 md:px-6 md:pt-36 lg:grid-cols-2 lg:gap-8">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-800">
            <i className="ri-sparkling-2-line" />
            女神系漫画 · 在线推荐阅读
          </span>
          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-foreground-950 md:text-5xl">
            发现属于你的
            <span className="block text-primary-600">女神系漫画</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            {siteName} 为你整理女神主角、神话女神、女神降临与养成等各类题材，提供清晰的分类导航与热门推荐，帮你快速找到想看的作品。
          </p>

          <form
            onSubmit={submitSearch}
            className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row sm:items-center"
          >
            <div className="relative flex-1">
              <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索作品或题材，例如：星辉女神录"
                aria-label="搜索漫画"
                className="w-full rounded-md border border-background-300 bg-background-50 py-3.5 pl-11 pr-4 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              />
            </div>
            <button
              type="submit"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即查找
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-400">大家都在搜：</span>
            {searchSuggestions.map((s) => (
              <button
                key={s}
                type="button"
                onClick={() => setKeyword(s)}
                className="cursor-pointer whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                {s}
              </button>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-8">
            <button
              type="button"
              onClick={goHot}
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              浏览分类
            </button>
            <button
              type="button"
              onClick={() => {
                const el = document.getElementById('featured');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="cursor-pointer whitespace-nowrap rounded-md border border-foreground-300 px-7 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              编辑精选
            </button>
            <div className="flex items-center gap-2">
              <i className="ri-star-fill text-accent-500" />
              <span className="text-sm text-foreground-600">
                汇集 <strong className="text-foreground-900">480+</strong> 部女神系作品
              </span>
            </div>
          </div>
        </div>

        <div className="order-1 flex items-center justify-center gap-4 lg:order-2 lg:justify-end">
          {heroCovers.map((c, i) => (
            <div
              key={c}
              className={`w-28 overflow-hidden rounded-xl border-4 border-background-50 shadow-sm md:w-36 ${
                i === 1 ? '-translate-y-4' : ''
              }`}
            >
              <img
                src={c}
                alt={`女神系漫画封面示例 ${i + 1}`}
                className="aspect-[3/4] w-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}